import { api } from "../lib/api";

export const list = (folderId) =>
  api
    .get("/documents", { params: folderId != null ? { folder_id: folderId } : {} })
    .then((r) => r.data);

export const get = (id) => api.get(`/documents/${id}`).then((r) => r.data);

export const getFile = (id) =>
  api
    .get(`/documents/${id}/file`, {
      responseType: "blob",
    })
    .then((response) => response.data);

export const getPreview = (id) =>
  api
    .get(`/documents/${id}/preview`, {
      timeout: 620000,
    })
    .then((response) => response.data);

export const getPreviewPage = (id, pageNumber) =>
  api
    .get(
      `/documents/${id}/preview/pages/${pageNumber}`,
      {
        responseType: "blob",
        timeout: 120000,
      }
    )
    .then((response) => response.data);

export const getPreviewSheet = (id, sheetNumber) =>
  api
    .get(
      `/documents/${id}/preview/sheets/${sheetNumber}`,
      {
        responseType: "text",
        timeout: 120000,
      }
    )
    .then((response) => response.data);

export const upload = (file, folderId) => {
  const fd = new FormData();
  fd.append("file", file);
  if (folderId) fd.append("folder_id", folderId);
  return api.post("/documents", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export const update = (id, payload) => api.put(`/documents/${id}`, payload).then((r) => r.data);

export const remove = (id) => api.delete(`/documents/${id}`).then((r) => r.data);

export const setAccess = (id, payload) =>
  api.put(`/documents/${id}/access`, payload).then((r) => r.data);

/**
 * Supprime plusieurs documents en une seule opération backend.
 *
 * Le backend contrôle l'appartenance de tous les documents
 * au tenant connecté avant d'effectuer la suppression.
 */
export const removeMany = (documentIds) =>
  api
    .post("/documents/bulk-delete", {
      document_ids: documentIds,
    })
    .then((response) => response.data);
